// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ArtifactPage-primaryButton-YMU-rb","page":"ArtifactPage-page-3L5Q9h","state":"ArtifactPage-state-3LP73K"};